import { useMemo } from 'react';
import { getRandomArrayElement, Job } from '~/shared';
import { usePlayerLevel } from '../../hooks';
import { AppCircuitGame } from '../AppCircuitGame';
import { AppConnectionSwitchGame } from '../AppConnectionSwitchGame';
import { AppConnectWiresGame } from '../AppConnectWiresGame';

const gamesByPlayerLevel = [
	{
		component: AppCircuitGame,
		minLevel: 1,
	},
	{
		component: AppConnectWiresGame,
		minLevel: 2,
	},
	{
		component: AppConnectionSwitchGame,
		minLevel: 3,
	},
];

function getRandomGameByPlayerLevel(playerLevel: number): React.FC {
	const availableGames = gamesByPlayerLevel.filter(
		(e) => playerLevel >= e.minLevel,
	);
	const randomItem = getRandomArrayElement(availableGames);
	return randomItem.component;
}

const AppJobElectrician = () => {
	const { playerLevel } = usePlayerLevel(Job.Electrician);

	const GameComponent = useMemo(
		() => getRandomGameByPlayerLevel(playerLevel),
		[playerLevel],
	);

	return <GameComponent />;
};

export { AppJobElectrician };
